<script>
import VLeaseDeviationsModal from "./VLeaseDeviationsModal.vue";

export default {
    components: { VLeaseDeviationsModal },
    props: {
        land_lease: { type: Object, required: true }
    },
    data() {
        return {
            showDeviationsModal: false,
            openAddForm: false
        };
    },
    computed: {
        hasDeviations() {
            return (
                Array.isArray(this.land_lease.land_lease_exceptions) &&
                this.land_lease.land_lease_exceptions.length > 0
            );
        }
    },
    methods: {
        openModal(withAddForm) {
            this.openAddForm = !!withAddForm;
            this.showDeviationsModal = true;
        },
        closeModal() {
            this.showDeviationsModal = false;
            this.openAddForm = false;
        }
    }
};
</script>

<template>
    <div class="v-lease-deviations-section">
        <h4>{{ $t("land_leases.deviations") }}</h4>
        <template v-if="hasDeviations">
            <div>
                <div>{{ $t("land_lease.contract_has_deviations") }}</div>

                <ul>
                    <li
                        v-for="v in land_lease.land_lease_exceptions"
                        :key="v.id"
                    >
                        {{ v.contract_point }}: {{ v.reason_notes }}
                        <badge
                            :type="v.change_type == 2 ? 'danger' : 'warning'"
                            >{{ v.change_type_text }}</badge
                        >
                    </li>
                </ul>

                <base-button
                    size="sm"
                    type="primary"
                    outline
                    @click="openModal(false)"
                >
                    {{ $t("land_leases.see_all_deviations") }}
                </base-button>
            </div>
        </template>
        <template v-else>
            <div>
                <div class="text-muted">
                    {{ $t("land_lease.contract_has_no_deviations") }}
                </div>
                <base-button
                    size="sm"
                    type="primary"
                    outline
                    class="mt-2"
                    @click="openModal(true)"
                >
                    {{ $t("land_leases.add_deviation") }}
                </base-button>
            </div>
        </template>

        <portal to="modals">
            <v-lease-deviations-modal
                v-if="showDeviationsModal"
                :land-lease="land_lease"
                :init-add-form="openAddForm"
                @close="closeModal"
            />
        </portal>
    </div>
</template>

<style lang="scss">
.v-lease-deviations-section {
    ul {
        padding-left: 15px;
    }
}
</style>
